import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
//Owl Carousel Settings
const options = {
    margin: 30,
    responsiveClass: true,
    nav: false,
    dots:false,
    loop:true,
    autoplay: true,
    smartSpeed: 10000,
    responsive: {
        0: {
            items: 2,
        },
        400: {
            items: 2,
        },
        600: {
            items: 2,
        },
        700: {
            items: 3,
        },
        1000: {
            items: 5,
        }
    },
};

function Client() {
    const clientData = [
        {
            id: 1,
            img: 'assets1/img/client-logo/1.png',
        },
        {
            id: 2,
            img: 'assets1/img/client-logo/3.png',
        },
        {
            id: 3,
            img: 'assets1/img/client-logo/2.png',
        },
        {
            id: 4,
            img: 'assets1/img/client-logo/4.png',
        },
        {
            id: 5,
            img: 'assets1/img/client-logo/5.png',
        },
        {
            id: 6,
            img: 'assets1/img/client-logo/6.png',
        },
        {
            id: 7,
            img: 'assets1/img/client-logo/7.png',
        },
        {
            id: 8,
            img: 'assets1/img/client-logo/8.png',
        },
        {
            id: 9,
            img: 'assets1/img/client-logo/9.png',
        },
        {
            id: 10,
            img: 'assets1/img/client-logo/10.png',
        },
    ]
    return (
        <>
            {/* <!--client section start--> */}
            <div className="client-section ptb-100"
                style={{
                    background: "url(assets1/img/client-bg.jpg)",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat'
                }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-lg-6">
                            <div className="client-heading-wrap">
                                <h3>Who are Happy With Services and Work</h3>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6">
                            <div className="client-para">
                                <p>The basic of business is to stay as close as possible from my customers, understand their behavior, their preferences, their purchasing patterns, etc. </p>
                            </div>
                        </div>
                    </div>
                    {/* <!--clients logo start--> */}
                    <div className="row align-items-center justify-content-center mb-4">
                        <div className="col-md-10 col-lg-9">
                            <OwlCarousel className="owl-carousel owl-theme clients-carousel dot-indicator client-logo-wrap"  {...options}>
                                {
                                    clientData.map((item,id) => (
                                        <div className="item single-client" key={id}>
                                            <img src={item.img} alt="client logo" className="client-img" />
                                        </div>
                                    ))
                                }
                            </OwlCarousel>
                        </div>
                    </div>
                    {/* <!--clients logo end--> */}
                </div>
            </div>
            {/* <!--client section end--> */}
        </>
    )
}

export default Client
